import { Component, OnInit } from '@angular/core';
import { AppService } from './app.service';
import { Router, NavigationEnd } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { CookiesService } from './cookies.service';
import { ARTIST_INFO, USER_STATUS_ID, COOKIE_USER_LOGGED, COOKIE_USER_TYPE } from './shared/constants';
import { AuthenticationService } from './shared/services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  private _SEOProperties = {
    home: {
      title: 'WindowSight | New Visual Arts Streaming Platform',
      description: 'Make your art available for streaming and get paid monthly on WindowSight. Reach an art loving community without limits and display art at home with our TV app.'
    },
    forArtist: {
      title: 'The Home For Art | WindowSight For Artists',
      description: 'Publish your art for free, get views and get paid on WindowSight. Boost your art’s exposure by streaming on the TVs worldwide from an art loving audience.'
    },
    theExperience: {
      title: 'Art For Home | Visual Arts Streaming Platform | WindowSight',
      description: 'Experience visual arts at home with the WindowSight online mobile and TV app.Stream and support established and upcoming artists worldwide.'
    },
    moreInfo: {
      title: 'Advantages, Features, Revenue and More | WindowSight For Artists',
      description: 'Joining WindowSight as an Artist means earning through our revenue system, being in control with our Image Manager and engaging with your new audience.'
    },
    about: {
      title: 'Making Art Accessible, Engaging and Democratic | WindowSight',
      description: 'Streaming has revolutionized music and film.It’s time for visual art.We make art an everyday experience by turning TVs into frames and empower artists along the way.'
    },
    contact: {
      title: 'Contact | Say Hi or Drop Any Questions | WindowSight',
      description: 'Are you an artist? Reach us at artist@windowsight.com'
    },
    login: {
      title: 'Log In | WindowSight',
      description: 'Turn your TV into an art display with fine and digital art, photography and designs from artists worldwide and engage in what’s happening in the arts.'
    },
    legal: {
      title: 'Legal Advice | WindowSight',
      description: 'WindowSight is an online Visual Arts Streaming Platform to explore, discover and display art directly from artists worldwide.'
    },
    privacyPolicy: {
      title: 'Privacy Policy | WindowSight',
      description: 'WindowSight is an online Visual Arts Streaming Platform to explore, discover and display art directly from artists worldwide.'
    }
  }

  constructor(
    private router: Router,
    private titleService: Title,
    private meta: Meta,
    private authenticationService: AuthenticationService,
    private _appService: AppService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = (<any>event.url || '');
        this.setSEO(url.replace('/', ''));
        if (url.includes('/settings') || url.includes('/statistics')) {
          document.getElementById('body').style.overflowY = 'hidden';
          document.getElementById('html').style.overflowY = 'hidden';
          document.getElementById('body').style.background = 'rgb(29,30,31)';
        } else if (url.includes('/signup')) {
          document.getElementById('body').style.background = 'black';
        } else {
          document.getElementById('body').style.overflowY = 'auto';
          document.getElementById('html').style.overflowY = 'auto';
          document.getElementById('body').style.background = 'white';
        }
      }
    });
    const artist = CookiesService.getItem(COOKIE_USER_TYPE);
    const loggedIn = CookiesService.getItem(COOKIE_USER_LOGGED);

  }

  ngOnInit() {
    this._appService.checkCurrentSessesion();
  }

  setSEO(section: string) {
    let data = this._SEOProperties.home;
    switch (section) {
      case 'for-artists': data = this._SEOProperties.forArtist; break;
      case 'the-experience': data = this._SEOProperties.theExperience; break;
      case 'for-artists/more-info': data = this._SEOProperties.moreInfo; break;
      case 'about': data = this._SEOProperties.about; break;
      case 'contact': data = this._SEOProperties.contact; break;
      case 'login': data = this._SEOProperties.login; break;
      case 'legal-advice': data = this._SEOProperties.legal; break;
      case 'privacy-policy': data = this._SEOProperties.privacyPolicy; break;
    }

    this.titleService.setTitle(data.title);
    this.meta.updateTag({ name: 'description', content: data.description })
  }
}
